import type { IconProps } from './types';

export function Brinco({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <circle cx="84" cy="60" r="24" />
      <path d="M84 84 Q84 124 84 168 Q90 192 96 216 Q90 224 84 232 Q78 224 72 216 Q78 192 84 168 Z" />
      <circle cx="172" cy="60" r="24" />
      <path d="M172 84 Q172 124 172 168 Q178 192 184 216 Q178 224 172 232 Q166 224 160 216 Q166 192 172 168 Z" />
    </svg>
  );
}
